import { useAppTranslation, useBackToShop } from "@/utils";
import { InfoCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

const PaySetPlanNoCreditAvailable = () => {
  const { t } = useAppTranslation();
  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex flex={1} vertical justify="center" align="center" gap={"large"}>
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />
        <Flex vertical className="tw:w-full" gap={"small"} align="center">
          <Typography.Title level={5} className="tw:m-0!">
            {t("pay.setPlan.noCreditAvailableTitle")}
          </Typography.Title>
          <Typography.Paragraph type="secondary" className="tw:m-0! tw:text-center!">
            {t("pay.setPlan.noCreditAvailableContent", { name: shopName })}
          </Typography.Paragraph>
        </Flex>
      </Flex>
      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Button
          onClick={() => {
            backToShop();
          }}
          type="primary"
          block
        >
          {shopName ? t("pay.returnTo", { name: shopName }) : t("common.returnToShop")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default PaySetPlanNoCreditAvailable;
